export const distanceUnits = {
    METERS: "METERS",
    FEET: "FEET",
    US_SURVEY_FEET: "US_SURVEY_FEET",
};
export const createMetricDistanceUnitPort = () => ({
    unit: distanceUnits.METERS,
    label: "m",
    toDisplay: (meters) => meters,
    toMeters: (displayValue) => displayValue,
});
//# sourceMappingURL=distance-unit.js.map